import React, { Fragment, memo, useCallback, useEffect, useState } from 'react'
import styles from './TeamMembers.module.scss'
import SelectedOptionTopBar from '../../../common/components/selected-option-top-bar/SelectedOptionTopBar'
import List from '../../../common/components/list/List'
import SelectedListItem from '../../../common/components/list/selected-list-item/SelectedListItem'
import { toast } from 'react-toastify'
import solarProviderService from '../../../httpService/SolarProviderService'
import { useNavigate } from 'react-router-dom'

type Props = {}

type TeamMember = {
    userId: string,
    firstName: string,
    lastName: string,
    type: string,
    status: string,
}

const TeamMembers: React.FC<Props> = memo((props: Props) => {
    const [ teamMembers, setTeamMembers] = useState<TeamMember[]>();
    const [ selectedItem, setSelectedItem] = useState<TeamMember>();
    const [ debouncedSearch, setDebouncedSearch ] = useState<string>('');
    const navigate = useNavigate();

    const fetchTeamMembers = useCallback(
        async () => {
            try {
                const response = await solarProviderService.getAllTeamMembers(debouncedSearch);
                
                setTeamMembers(response.data.teamMembers);
            } catch (error : any) {
                toast.error(error?.response?.data?.title ?? "There was an error")
            }
        },
        [debouncedSearch, setTeamMembers],
    )

    useEffect(() => {
        fetchTeamMembers();
    }, [fetchTeamMembers])

    const selectListItem = (item: any) => {
        setSelectedItem(item)
    }

    const removeMember = async (item: any) => {
        try {
            await solarProviderService.removeTeamMember({
                userId: item.userId
            });
            setSelectedItem(undefined);
            await fetchTeamMembers();
        } catch (error : any) {
            toast.error(error?.response?.data?.title ?? "There was an error")
        }
        
    }

    const toogleMemberActivity = async () => {
        try {
            await solarProviderService.toggleActivateTeamMember({
                userId: selectedItem?.userId
            });

            teamMembers?.forEach(x => {
                if (x.userId === selectedItem?.userId) {
                    x.status = x.status === 'Active' ? 'Deactivated' : 'Active';
                }
            });

            if (teamMembers != null)
                setTeamMembers([...teamMembers]);

        } catch (error : any) {
            toast.error(error?.response?.data?.title ?? "There was an error")
        }
    }    

    const searchList = (searchContent: string) => {
        setDebouncedSearch(searchContent);
    }

    return (
        <Fragment>
            <SelectedOptionTopBar title='View Team Members' />
            <div className={styles.mainPane}>
                <List title='Team Members' buttonTitle='Add New Team Member' onSelectListItem={selectListItem} items={teamMembers} onButtonHandler={removeMember} onSearchHandler={searchList} onTopButtonHandler={() => navigate('add')} />
                {selectedItem != null && (
                    <div className={styles.itemDetails}>
                        <SelectedListItem item={selectedItem} onBackHandler={() => setSelectedItem(undefined)} toggleButtonHandler={toogleMemberActivity}/>
                    </div>
                )}
            </div>
        </Fragment>
    )
})

export default TeamMembers